import { useSearchParameter } from "hooks";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Modal, PersonInfo } from "ui";

import { useRefundById } from "../../../apis";
import { ConfirmRefundModal } from "../ConfirmRefundModal";
import { RefundOrderDetails, RefundPaymentDetails } from "./atoms";
import { AddExpenseModalProps } from "./RefundDetailsModal.types";

import styles from "./RefundDetailsModal.module.scss";

const RefundDetailsModal = ({
  isOpen,
  onClose,
  refetchRefundsList
}: AddExpenseModalProps) => {
  const { t } = useTranslation();
  const [refundId] = useSearchParameter("refundId");
  const { refund, refetch: refetchOpenedRefund } = useRefundById(refundId);
  const [isConfirmingRefund, setIsConfirmingRefund] = useState(false);

  return (
    <Modal
      isOpen={isOpen}
      title={t("Refund Details")}
      onClose={onClose}
      footer={<></>}
      className={styles.modal}
      contentClassName={styles.modal__refund}
    >
      {refund && (
        <>
          <div className={styles["modal__refund--reseller"]}>
            <PersonInfo
              topText={t("Reseller")}
              personName={`${refund.reseller.firstname} ${refund.reseller.lastname}`}
              dimensions={{ width: 32, height: 32, borderRadius: "50px" }}
              image={refund.reseller.image}
              nameClassName={styles["modal__refund--reseller-name"]}
            />
            {!refund.isRefunded ? (
              <Button onClick={() => setIsConfirmingRefund(true)}>
                {t("Confirm")}
              </Button>
            ) : (
              <p className={styles["modal__refund--sentLabel"]}>
                {t("Refund sent")}
              </p>
            )}
          </div>

          <RefundOrderDetails refund={refund} />

          <div className={styles["modal__refund--separator"]} />

          <RefundPaymentDetails refund={refund} />
          {isConfirmingRefund && (
            <ConfirmRefundModal
              refundId={refund.id}
              isOpen={isConfirmingRefund}
              onClose={() => setIsConfirmingRefund(false)}
              onSuccess={() => {
                refetchRefundsList();
                refetchOpenedRefund();
              }}
            />
          )}
        </>
      )}
    </Modal>
  );
};

export default RefundDetailsModal;
